import React, {Component} from 'react'
import {connect} from 'react-redux'
import {setIsLoading} from '../../actions/common'
import {refreshNavigation} from '../../actions/navigation'
import {loginPageUrl, dashboardPageUrl, storeTokenParams, clearStoredTokenParams, buildQueryStringForGettingTokenFromProvider} from '../../panel-admin/common/functions/auth'
import {clearCountrySettings, setAllowedCountries, setSelectedCountry, setSubcommunities, getSubCommunities, getSelectedCountryCode, setSelectedSubcommunity} from '../../panel-admin/common/functions/countrySetting'
import {clearAssignedPermissions, setAssignedPermissions} from '../../panel-admin/common/functions/permissions'
import WithAjax from '../../panel-admin/common/helpers/WithAjax'
import Form from '../Form'


class Login extends Component {
  constructor() {
    super()

    this.state = {
      loginError: false
    };

    this.clearLoggedUser();
  }

  componentDidMount() {
    this.props.setIsLoadingParam(false);
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    const microsoftAuthCode = urlSearchParams.get('code');
    if (microsoftAuthCode != null) {
      this.props.setIsLoadingParam(true);
      var dataToSend = buildQueryStringForGettingTokenFromProvider("Microsoft", microsoftAuthCode);
      this.tokenPostLocal(dataToSend);
    }
  }

  buildMicrosoftLogInUrl() {
    return "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?"+
      "client_id="+ process.env.REACT_APP_MS_LOGIN_CLIENT_ID +
      "&response_type=code&"+
      "redirect_uri="+process.env.REACT_APP_MS_LOGIN_REDIRECT_URI +
      "&response_mode=query&scope="+process.env.REACT_APP_MS_LOGIN_SCOPE +
      "&state=nort6g16o38G9IXPHlLe2V77OaA09U";
  }

  tokenPostLocal(dataToSend) {
    this.props.ajax.tokenPost(
      dataToSend,
      (response) => {
        if (response.error) {
          this.setState({
            loginError: true
          });
          this.props.history.push(loginPageUrl);
        }
        else {
          storeTokenParams(response);

          // get country settings
          // It is small hack with adding "pl" to url. Ideally server should response even the country code is empty.
          this.props.ajax.get('pl/settings', false, (data) => {
            if (data) {
              console.log(data);
              this.setState({
                loginError: false
              })
              setAllowedCountries(data.CountryCodes)

              if(window.localStorage.selectedCountryCode && data.CountryCodes.includes(window.localStorage.selectedCountryCode.toUpperCase()))
              {
                setSelectedCountry(window.localStorage.selectedCountryCode.toLowerCase())
              }else{
                setSelectedCountry(data.CountryCodes.split(',')[0].toLowerCase())
              }


              if(data.Subcommunities && data.Subcommunities.length>0){
                setSubcommunities(data.Subcommunities)
                if(window.localStorage.selectedSubcommunity !==null && typeof window.localStorage.selectedSubcommunity !== "undefined" && data.Subcommunities)
                {
                  setSelectedSubcommunity(window.localStorage.selectedSubcommunity)
                }else{
                  setSelectedSubcommunity(data.Subcommunities.split(',')[0]);
                }
              }

              setAssignedPermissions(data.Permissions)


              this.props.refreshNavigation();

              this.props.history.push(dashboardPageUrl);
            }
            else {
              this.clearLoggedUser();

              this.setState({
                loginError: true
              })
            }
          })
        }
      })
  }

  clearLoggedUser() {
    clearStoredTokenParams();
    clearCountrySettings();
    clearAssignedPermissions();
  }

  render() {
    return (
      <Form
        title="Login"
        description="Sign in with your Iyuno account">

        {this.state.loginError &&
          <div className="form-text text-danger mb-2">
            You have no access to produb admin
          </div>
        }

       {<div><small>Please use your @iyuno.com email address</small></div>}
       {<a href={this.buildMicrosoftLogInUrl()}><div className="ms-signin-button">Sign In with Microsoft</div></a>}
      </Form>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
})
const mapDispatchToProps = dispatch => ({
  setIsLoadingParam(isLoading) { dispatch(setIsLoading(isLoading)) },
  refreshNavigation() { dispatch(refreshNavigation()) }
})


export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(Login))
